import { useState } from 'react';
import type { ReactNode } from 'react';
import { iniciais } from '../acesso';
import { enderecoDaFoto, useFotoDaConta } from '../foto-de-perfil';
import './foto-de-perfil.css';

/**
 * O MIOLO do avatar: a foto de perfil quando existe, senão as iniciais (ou o que a tela passar em
 * `semFoto`). Vai DENTRO do círculo que cada tela já tem (`pr-avatar`, `ac-avatar`…): a tela
 * continua dona do tamanho e da cor; a foto só preenche o círculo.
 *
 * Imagem que não carrega (foto tirada depois que a lista veio, sessão caída) volta às iniciais —
 * nunca um ícone de imagem quebrada.
 */
export function FotoOuIniciais({
  foto,
  nome,
  semFoto,
}: {
  foto: string | null | undefined;
  nome: string;
  semFoto?: ReactNode;
}) {
  const [falhou, setFalhou] = useState<string | null>(null);
  if (foto && falhou !== foto)
    return (
      <img
        className="foto-de-perfil"
        src={enderecoDaFoto(foto)}
        alt=""
        draggable={false}
        onError={() => setFalhou(foto)}
      />
    );
  return <>{semFoto ?? iniciais(nome)}</>;
}

/** Mesmo miolo, para quem só tem a CONTA da pessoa (Equipe, Premiação…). */
export function FotoDaConta({
  accountId,
  nome,
  semFoto,
}: {
  accountId: string | null | undefined;
  nome: string;
  semFoto?: ReactNode;
}) {
  const foto = useFotoDaConta(accountId);
  return <FotoOuIniciais foto={foto} nome={nome} semFoto={semFoto} />;
}
